import React, { memo } from 'react';
import { DndProvider } from 'react-dnd';
import { Col, Row } from 'antd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import WidgetForm from './WidgetForm';
import Toolbar from './Toolbar';

const WidgetFormBuilder = memo(() => {
  return (
    <DndProvider backend={HTML5Backend}>
      <Row gutter={16}>
        <Col span={18}>
          <WidgetForm />
        </Col>
        <Col span={6}>
          <Toolbar />
        </Col>
      </Row>
    </DndProvider>
  );
});

export default WidgetFormBuilder;
